module.exports = __webpack_public_path__ + "img/login-top.6a832822.png";